import { SearchResultsSortKey } from './SearchResultsSortKey';

export const isValidSortValue = (
    sort: string | SearchResultsSortKey,
): sort is SearchResultsSortKey =>
    Object.values(SearchResultsSortKey).includes(sort as SearchResultsSortKey);
